<template>
  <span>
    <MglGeojsonLayer
      :source-id="source.id"
      :source="source.json"
      :layer-id="layer.id"
      :layer="layer.json"
    />

    <MglGeojsonLayer
      :source-id="source.id"
      :source="source.json"
      :layer-id="namelayer.id"
      :layer="namelayer.json"
    />
  </span>
</template>

<script>
import axios from 'axios'
import Mapbox from 'mapbox-gl'
import { MglGeojsonLayer } from 'vue-mapbox'

export default {
  name: 'BouyLayer',
  inject: ['mapbox', 'map', 'actions'],
  components: {
    MglGeojsonLayer
  },
  props: {
    raceId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: 'true',
      buoyData: [],
      layer: {
        id: 'buoys',
        json: {
          type: 'symbol',
          source: 'buoys-source',
          layout: {
            'icon-image': 'buoy',
            'icon-allow-overlap': true,
          },
        },
      },
      namelayer: {
        id: 'buoys-names',
        json: {
          type: 'symbol',
          source: 'buoys-source',
          layout: {
            'symbol-placement': 'point',
            'text-font': ['Klokantech Noto Sans Regular'],
            'text-field': '{title}',
            'text-size': 8,
            'text-offset': [0, 1.5],
          },
          paint: {
            'text-color': '#263b59',
            'text-halo-color': '#fff',
            'text-halo-width': 1,
          },
        }
      }
    }
  },
  computed: {
    source () {
      /*
      [
          {
              "Name": "Inner Mark",
              "Coordinate": {
                  "Latitude": -33.87359,
                  "Longitude": 151.23187
              },
              "Terminal": "3337"
          },
          {
              "Name": "Outer Mark",
              "Coordinate": {
                  "Latitude": -33.8734,
                  "Longitude": 151.233
              },
              "Terminal": "6333"
          }
      ]
      */

      if (this.loading) { 
        return {
          id: 'buoys-source',
          json: {
            'type': 'geojson',
            'data': {
              'type': 'FeatureCollection',
              'features': []
            },
            'cluster': false
          }
        }
      }

      try {
        return {
          id: 'buoys-source',
          json: {
            'type': 'geojson',
            'data': {
              'type': 'FeatureCollection',
              'features': [
                {
                    'type': 'Feature',
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [this.buoyData[0].Coordinate.Longitude, this.buoyData[0].Coordinate.Latitude]
                    },
                    'properties': {
                      'title': this.buoyData[0].Name
                    }
                },
                {
                    'type': 'Feature',
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [this.buoyData[1].Coordinate.Longitude, this.buoyData[1].Coordinate.Latitude]
                    },
                    'properties': {
                      'title': this.buoyData[1].Name
                    }
                }
              ]
            },
            'cluster': false
          }
        }
      } 
      catch (e) {
        console.info('invalid or no buoy data', e)
        // invalid buoy data
        return {
          id: 'buoys-source',
          json: {
            'type': 'geojson',
            'data': {
              'type': 'FeatureCollection',
              'features': []
            },
            'cluster': false
          }
        }
      }
    }
  },
  async created () {
    this.fetchBuoys()

    await this.loadImage('buoy', '/tracker/TrackerIcons/buoy_sm3.png')

    this.loading = false
  },
  methods: {
    fetchBuoys () {
      axios
      .get(`${window.BASE_FEEDS_URL}finishline/${this.raceId}`)
      .then(response => {
        this.buoyData = response.data
      })
      .catch(error => {
        this.errored = true
        // eslint-disable-next-line
          console.log(error)
      })
      .then(() => this.loading = false)
    },
    loadImage(name, url) {
      const vm = this
      return new Promise((resolve, reject) => {
        vm.map.loadImage(url, (error, image) => {
          if (error) {
            reject()
          }
          if (!vm.map.hasImage(name)) {
            vm.map.addImage(name, image)
          }
          resolve()
        })
      })
    }
  }
}
</script>